import api from '../../../services/Api';
import { IAuditoriaTransferPricingResultado } from '../interfaces/IAuditoriaTransferPricing';

const resultadoVazio: IAuditoriaTransferPricingResultado = {
  exposicaoFinanceiraTotalGeral: 0,
  passivoTributarioPrincipalTotal: 0,
  multaQualificadaTotal: 0,
  multaAcessoriaTotal: 0,
  impactoFiscalTotal: 0,
  totalErros: 0,
  totalAlertas: 0,
  totalAvisos: 0,
  status: 'CONCILIADO',
  mensagemDirecionamento: '',
  fundamentacaoLegal: '',
  itens: [],
};

export const AuditoriaTransferPricingService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaTransferPricingResultado> {
    const response = await api.get<IAuditoriaTransferPricingResultado>(
      'auditoria-transfer-pricing/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo || '' } }
    );
    return response.data || resultadoVazio;
  },
};
